<div class="table-dropdown" *ngIf="dropDownOption">
  <button class="btn-select-dropdown" [matMenuTriggerFor]="checkboxMenu" #menuTrigger="matMenuTrigger">
    <span> {{
      selectedItem.length === 0
        ? (chooseOptions | translate)
        : selectedOptions.length === 1
          ? selectedOptions[0]
          : selectedOptions[0] + ' (+' + (selectedOptions.length - 1) +')'
    }}</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #checkboxMenu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
    class="grades-menu-selection residential-menu" (closed)="onMenuClosed()">
    <div (click)="$event.stopPropagation()">
      <h5 class="menu-label" *ngIf="!search">
        {{ chooseOptions | translate }}
      </h5>
      <div class="search-item"  *ngIf="search">
        <input type="text" (input)="filterOptions()" [(ngModel)]="searchText" placeholder="{{'reports.search_neighborhoods' | translate}}">
        <svg width="16" height="17" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 12.5698L10.014 9.58373C10.9 8.46041 11.3234 7.04097 11.1974 5.61579C11.0715 4.19062 10.4058 2.86742 9.3364 1.91691C8.26705 0.966392 6.87493 0.460392 5.44482 0.502424C4.0147 0.544455 2.6547 1.13134 1.64302 2.14302C0.631341 3.1547 0.0444549 4.5147 0.00242357 5.94482C-0.0396078 7.37493 0.466392 8.76705 1.41691 9.8364C2.36742 10.9058 3.69062 11.5715 5.11579 11.6974C6.54097 11.8234 7.96041 11.4 9.08373 10.514L12.0698 13.5L13 12.5698ZM5.62731 10.4034C4.78158 10.4034 3.95483 10.1526 3.25163 9.68278C2.54842 9.21291 2.00034 8.54507 1.67669 7.76371C1.35304 6.98235 1.26836 6.12257 1.43336 5.29308C1.59835 4.4636 2.00561 3.70167 2.60364 3.10364C3.20167 2.50561 3.9636 2.09835 4.79308 1.93336C5.62257 1.76836 6.48235 1.85304 7.26371 2.17669C8.04507 2.50034 8.71291 3.04842 9.18278 3.75163C9.65264 4.45483 9.90343 5.28158 9.90343 6.12731C9.90204 7.26098 9.45107 8.34782 8.64945 9.14945C7.84782 9.95107 6.76098 10.402 5.62731 10.4034Z"
            fill="#6C737F" />
        </svg>
      </div>
      <ng-container *ngIf="json_data; else plainOptions">
        <ng-container *ngFor="let data of filteredOptions">
          <ng-container *ngIf="unit; else defaultOptions">
            <mat-checkbox (change)="toggleResidentialType($event, data.label[1], menuTrigger)" [checked]="selectedItem.includes(data.label[1])">
              {{ data.label | langtranslate }}
            </mat-checkbox>
          </ng-container>
          <ng-template #defaultOptions>
            <mat-checkbox (change)="toggleResidentialType($event, data.name, menuTrigger)" [checked]="selectedItem.includes(data.name)">
              {{ data.label | langtranslate }}
            </mat-checkbox>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #plainOptions>
        <ng-container *ngFor="let data of filteredOptions">
          <mat-checkbox (change)="toggleResidentialType($event, data, menuTrigger)" [checked]="selectedItem.includes(data)">
            {{ data}}
          </mat-checkbox>
        </ng-container>
      </ng-template>
      <div class="no-result-found" *ngIf="filteredOptions?.length == 0">{{'reports.no-result-found'|translate}}</div> 
    </div>
  </mat-menu>

</div>